import frontendAppAuthnMessages from './messages/@openedx/frontend-app-authn';
import frontendAppInstructorDashboardMessages from './messages/@openedx/frontend-app-instructor-dashboard';
import frontendAppLearnerDashboardMessages from './messages/@openedx/frontend-app-learner-dashboard';
import frontendAppNotificationsMessages from './messages/@openedx/frontend-app-notifications';
import frontendBaseMessages from './messages/@openedx/frontend-base';
import paragonMessages from './messages/@openedx/paragon';

export default [
  frontendAppAuthnMessages,
  frontendAppInstructorDashboardMessages,
  frontendAppLearnerDashboardMessages,
  frontendAppNotificationsMessages,
  frontendBaseMessages,
  paragonMessages,
];
